









import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
@Component({ components: {} })
export default class PageNation extends Vue {
  @Prop({ default: [] })
  private rows!: any[];

  @Prop({ default: 10 })
  private pageSize!: number;

  private currentPage = 0;

  private get total() {
    return Math.ceil(this.rows.length / this.pageSize);
  }

  get paginations(): number[] {
    // 連番配列を取得
    return Array.from({ length: this.total }, (v, k) => k);
  }

  @Watch('rows')
  init() {
    this.pageChanged(0);
  }

  pageChanged(index: number) {
    this.currentPage = index;
    const start = this.currentPage * this.pageSize;
    const end = (this.currentPage + 1) * this.pageSize;
    console.log(start, end);
    const rowInPage = this.rows.slice(start, end);
    this.$emit('on-page-changed', rowInPage, this.currentPage, this.total);
  }
}
